export default __webpack_public_path__ + "static/media/icon.disinfector.fb735ef2.svg";